import React from "react";
import { compose } from "redux";

import { getLoginWithRedirectUrl } from "../../../../../lib/auth/authRedirectUrl";
import withTranslations from "../../../../../hocs/withTranslations";
import { ACCESS_DENIED_REASON } from "../../../../../lib/api/accessDeniedError";
import { showModal } from "../../../../../lib/react-redux-modal-provider";
import useNextPlans from "../../../../../hooks/useNextPlans";
import IconMessage from "../../IconMessage";
import Loader from "../../Loader";
import noPermissionIcon from "../assets/no-permission.svg";

const DEFAULT_DESCRIPTION_KEY = "no_permission_for_plan_tab_description";

const openUpgradePlanModal = permissions => {
  showModal("PremiumModal", {
    skipShowIfAlreadyVisible: true,
    permissions
  });
};

const NoPermissionForPlan = ({
  translate,
  locale,
  className,
  permissions,
  accessDeniedReason,
  descriptionTranslationKey = DEFAULT_DESCRIPTION_KEY,
  onLinkClick,
  imageSrc,
  imageHeight = 110,
  imageWidth = 146
}) => {
  const handleUpgradeClick = event => {
    openUpgradePlanModal(permissions);
    if (onLinkClick) {
      onLinkClick(event);
    }
  };

  const commonProps = {
    onLinkClick: handleUpgradeClick,
    imageSrc: imageSrc ?? noPermissionIcon,
    imageHeight,
    imageWidth,
    className
  };

  if (accessDeniedReason === ACCESS_DENIED_REASON.NOT_AUTHENTICATED) {
    return (
      <IconMessage
        {...commonProps}
        onLinkClick={onLinkClick}
        title={translate("Sign in required")}
        description={translate("sign_in_required_to_view_feature_description")}
        link={getLoginWithRedirectUrl({ locale })}
        linkText={translate("Log in")}
      />
    );
  }

  const { response, loading, error } = useNextPlans({ permissions, locale });
  const plan = response?.[0];

  if (loading) {
    return (
      <div className={className}>
        <Loader small />
      </div>
    );
  }

  if (error || !plan?.name || !plan?.id) {
    if (error?.response?.status === 404) {
      return (
        <IconMessage
          {...commonProps}
          title={translate("noPermissionNotifications_no-plan_error-title")}
        />
      );
    }

    return (
      <IconMessage
        {...commonProps}
        title={translate("noPermissionNotifications_error-title")}
      />
    );
  }

  return (
    <IconMessage
      {...commonProps}
      linkText={translate("noPermissionNotifications_link-text")}
      description={translate(descriptionTranslationKey, {
        planName: plan.name
      })}
      title={translate("noPermissionNotifications_title")}
    />
  );
};

export default compose(withTranslations)(NoPermissionForPlan);
